<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    @click="
                      $router.push({
                        name: 'client_apps_detail',
                        params: { id: 'new' },
                      })
                    "
                    type="button"
                    class="btn btn-success waves-effect waves-light"
                  >
                    <i class="bx bx-plus font-size-16 align-middle mr-2"></i>
                    New Client Apps
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">ค้นหา</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.keyword"
                      type="text"
                      placeholder="รหัส / ชื่อ / Email / โดเมน"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4"></div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="form-row form-group">
                  <label class="col-md-2 col-form-label">สถานะ</label>
                  <div class="col-form-label row" style="margin-left: 0px">
                    <b-form-checkbox
                      @change="onSelectAll($event)"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="all"
                      id="all"
                      v-model="isSelectAllStatus"
                      >All</b-form-checkbox
                    >
                    <div
                      v-for="(data_status, index) in selectAllStatus"
                      :key="index"
                    >
                      <b-form-checkbox
                        v-model="filter.status"
                        :value="data_status"
                        :class="
                          data_status.toLowerCase() === 'active'
                            ? 'custom-checkbox-success'
                            : 'custom-checkbox-danger'
                        "
                        class="custom-checkbox custom-checkbox-outline mb-3"
                        style="margin-right: 10px"
                        :name="data_status.toLowerCase()"
                        :id="data_status.toLowerCase()"
                        >{{ data_status }}
                      </b-form-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-lg-12 text-sm-right">
                    <div class="button-items">
                      <button
                        type="button"
                        class="btn btn-primary waves-effect"
                        @click="onFilter()"
                      >
                        <i
                          class="bx bx-search font-size-16 align-middle mr-2"
                        ></i>
                        Search
                      </button>
                      <button
                        type="button"
                        class="btn btn-light waves-effect"
                        @click="onReset()"
                      >
                        <i
                          class="bx bx-reset font-size-16 align-middle mr-2"
                        ></i>
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="showDataTable">
          <div class="card-body">
            <div class="row form-group">
              <div class="col-sm-12 col-md-9">
                <div id="tickets-table_length" class="dataTables_length">
                  <span>จำนวน</span>
                  <label class="d-inline-flex align-items-center">
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onFilter()"
                      class="ml-3"
                    ></b-form-select>
                  </label>
                  <span class="ml-2"
                    >จากทั้งหมด {{ totalRecords | number }} รายการ</span
                  >
                </div>
              </div>
              <div class="col-sm-12 col-md-3">
                <div class="input-group md-form form-sm text-md-right">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <span class="bx bx-search-alt"></span>
                    </span>
                  </div>
                  <input
                    v-model="search"
                    class="form-control my-0 py-1"
                    type="search"
                    placeholder="ค้นหา"
                    aria-label="Search"
                  />
                  <div class="button-items ml-1"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="brandtable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="!hasItems"
                    :bordered="true"
                    :filter="search"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                    @filtered="onFiltered"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (firstRowOnPage + data.index) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>

                    <template v-slot:cell(app_domains)="data">
                      <div
                        v-for="(itemApp, indexApp) in data.item.app_domains"
                        v-bind:key="indexApp"
                      >
                        <span
                          class="badge badge-pill badge-soft-success font-size-11"
                          >{{ itemApp }}</span
                        >
                        <br />
                      </div>
                    </template>

                    <template v-slot:cell(action)="data">
                      <div class="text-center">
                        <a
                          @click="
                            $router.push({
                              name: 'client_apps_detail',
                              params: { id: data.item.id },
                            })
                          "
                          class="btn btn-ico text-info"
                          title="View"
                          ><i class="bx bx-show"></i
                        ></a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row" v-if="hasItems">
              <div class="col-lg-4">
                <div style="position: relative; top: 7px">
                  รายการที่ {{ firstRowOnPage | number }} -
                  {{ lastRowOnPage | number }} จากทั้งหมด
                  {{ totalRecords | number }} รายการ
                </div>
              </div>
              <div class="col-lg-8">
                <b-pagination
                  :total-rows="totalRecords"
                  :per-page="perPage"
                  v-model="pageNo"
                  @change="onClickPagination($event)"
                  class="pagination pagination-rounded justify-content-end mb-2"
                />
              </div>
            </div>
          </div>
        </div>
        <loading :active.sync="isLoading"></loading>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import { FormatQty } from "@/helpers/utils/format-qty.js";
import clientAppsService from "@/helpers/service/client-apps-service";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { eventBus } from "@/main.js";
import { clientAppsComputed, clientAppsMethods } from "@/state/helpers";
import { StatusEnum } from "@/enum/status.enum.js";
import { OptionCheckboxClientAppsStatus } from "@/helpers/utils/status.js";

export default {
  name: "ClientApps",
  page: {
    title: "Client Apps",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
  },
  data() {
    return {
      search: null,
      title: "Client Apps",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Brand",
          active: true,
        },
      ],
      fields: [
        {
          key: "index",
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0);
          },
          label: "ลำดับ",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "display_name",
          label: "ชื่อ Apps",
          sortable: true,
        },
        {
          key: "app_namespace",
          label: "Namespace",
          sortable: true,
        },
        {
          key: "app_domains",
          label: "Domains",
          sortable: true,
        },
        {
          key: "contact_email",
          label: "อีเมลผู้ติดต่อ",
          sortable: true,
        },
        {
          key: "status",
          label: "สถานะ",
          thStyle: "width:120px",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 1,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 10,
            prevPage: 0,
            nextPage: 0,
          };
        },
      },
      items: [],
      pageNo: 1,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 10,
      filter: {
        keyword: "",
        contact_email: "",
        status: [],
      },
      isSelectAllStatus: true,
      pageOptions: [10, 25, 50, 100],
      showDataTable: false,
      selectAllStatus: [],
    };
  },
  computed: {
    ...clientAppsComputed,
    hasItems() {
      return this.$validate.anyArrayObjectValid(this.items);
    },
  },
  mounted() {
    // console.log(
    //   "OptionCheckboxClientAppsStatus :>> ",
    //   OptionCheckboxClientAppsStatus
    // );
    this.selectAllStatus = OptionCheckboxClientAppsStatus;

    console.log("mounted", this.selectAllStatus);

    // this.filter = Object.assign({}, this.GET_FILTER_CLIENT_APPS);
    // if (this.filter.isFilter) {
    this.onFilter();
    // }
  },
  watch: {
    "filter.status": {
      handler() {
        console.log(" this.filter.status", this.filter.status);

        this.isSelectAllStatus =
          this.filter.status.length === this.selectAllStatus.length
            ? true
            : false;
      },
      deep: true,
    },
    isSelectAllStatus: {
      handler(newVal) {
        if (newVal) {
          this.filter.status = OptionCheckboxClientAppsStatus;
        }
      },
      immediate: true,
    },
    GET_FILTER_CLIENT_APPS(val, oldVal) {
      this.filter = Object.assign({}, val);
    },
    listModel: function (value) {
      this.totalPages = value.totalPages;
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1;
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords);
      this.totalRecords = value.totalRecords;

      // if (this.showDataTable) {
      //   this.$refs.brandtable.localSortBy = "";
      // }
      this.items = value.items;
      this.perPage = value.pageSize;
      this.pageNo = value.pageNo;
    },
  },
  methods: {
    ...clientAppsMethods,
    onSelectAll(event) {
      this.filter.status = event ? this.selectAllStatus : [];
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    async onClickPagination(pageNo) {
      this.search = "";
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      params.append("page", pageNo);
      params.append("keyword", this.filter.keyword.trim() || "");
      params.append("sort", "create_info.timestamp");
      this.filter.status.forEach((element) => {
        params.append("status", element);
      });

      let result = await clientAppsService.getClientAppsAsync(params);
      if (result.status === 200) {
        this.listModel = result.data;
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
    async onFilter() {
      this.isLoading = true;
      this.showDataTable = false;
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      params.append("keyword", this.filter.keyword.trim() || "");
      params.append("sort", "create_info.timestamp");
      this.filter.status.forEach((element) => {
        params.append("status", element);
      });

      let result = await clientAppsService.getClientAppsAsync(params);
      if (result.status === 200) {
        this.isLoading = false;

        this.listModel = result.data;
        this.showDataTable = true;
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      }
      // this.ADD_FILTER_CLIENT_APPS(this.filter);
    },
    onReset() {
      this.filter.keyword = "";
      this.filter.status = [];
      // this.items = [];
      this.isSelectAllStatus = true;
      this.filter.status = ["Active", "Inactive"];
      this.CLEAR_FILTER_CLIENT_APPS();
    },
    async onConfirmDelete(id, name) {
      await this.$utils
        .confirmAlertDisplay(
          `คุณต้องการเปลี่ยนสถานะข้อมูล ${name} เป็น Delete ใช่หรือไม่`,
          ""
        )
        .then((result) => {
          if (result) {
            this.onDelete(id);
          }
        });
    },
    async onDelete(id) {
      let result = await clientAppsService.deleteBrandMasterByIdAsync(id);
      if (result.status && result.status === 204) {
        this.$utils.notification(
          "success",
          "เปลี่ยนข้อมูลเป็นสถานะ Delete สำเร็จ",
          1500
        );
        this.onFilter();
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification("error", result.response.data.message, 2000);
      }
    },
  },
};
</script>
<style></style>
